<template>
  <div>
    <customize-page
      label-position="left"
      ref="page"
      inline
      :loading="loading"
      :data="dataList"
      :columns="columns"
      :pagination="pagination"
      :formConfig="getFormConfig()"
      :filterObj="filterObj"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
      <div slot="footer">
        <el-button style="margin-right: 10px" type="primary" @click="search">
          搜索
        </el-button>
        <el-button style="margin-right: 10px" @click="reset">重置</el-button>
        <el-button
          style="margin-right: 10px"
          type="primary"
          v-hp="'add'"
          @click="showAddOrModifyView(null)"
        >
          新增
        </el-button>
      </div>
    </customize-page>

    <el-dialog
      :title="(formData.id === '' ? '新增' : '修改') + '渠道电商平台'"
      width="450px"
      :visible.sync="showFormDialog"
    >
      <el-form
        style="width: 400px; margin: 0 auto"
        ref="form"
        :model="formData"
        label-width="120px"
      >
        <el-form-item label="渠道">
          <el-select
            :disabled="formData.id !== ''"
            v-model="formData.channelCode"
          >
            <el-option
              v-for="item in allChannelList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="电商平台">
          <el-select filterable v-model="formData.eNid">
            <el-option
              v-for="item in getPECommerce"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="申报类型">
          <el-select v-model="formData.payDeclareType">
            <el-option
              v-for="item in payDeclareTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="save()">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import CustomizePage from "@/components/customize-page";
import Page from "@/mixin/Page";

import { mapActions, mapGetters, mapState } from "vuex";

export default {
  components: {
    CustomizePage,
  },
  mixins: [Page],
  created() {
    this.defaultFormData = JSON.stringify(this.formData);
  },
  mounted() {
    this.fetch();
  },
  data() {
    return {
      loading: false,
      dataList: [],
      showFormDialog: false,
      defaultFormData: "",
      payDeclareTypeList: [
        { value: "MERCHANT_DECLARE", label: "商家侧申报" },
        { value: "ERP_DECLARE", label: "平台侧申报" },
      ],
      formData: {
        id: "",
        channelCode: "",
        eNid: "",
        payDeclareType: "",
        operator: "",
      },
      columns: [
        {
          type: "selection",
          width: 50,
          align: "center",
        },
        {
          title: "渠道名",
          minWidth: 90,
          key: "channelName",
          align: "center",
        },
        {
          title: "渠道编码",
          width: 160,
          key: "channelCode",
          align: "center",
        },
        {
          title: "申报类型",
          width: 120,
          key: "payDeclareType",
          align: "center",
        },
        {
          title: "电商平台标识",
          width: 120,
          key: "peNid",
          align: "center",
        },
        {
          title: "电商平台名",
          minWidth: 300,
          key: "enterpriseName",
          align: "center",
        },
        {
          title: "海关备案名",
          minWidth: 300,
          key: "enterpriseCustomsName",
          align: "center",
        },
        {
          title: "海关备案编吗",
          width: 120,
          key: "enterpriseCustomsCode",
          align: "center",
        },
        {
          title: "创建时间",
          width: 180,
          key: "gmtCreate",
          align: "center",
        },
        {
          title: "修改人",
          width: 160,
          key: "modifier",
          align: "center",
        },
        {
          title: "修改时间",
          width: 180,
          key: "gmtModified",
          align: "center",
        },
        {
          title: "操作",
          width: 180,
          align: "center",
          fixed: "right",
          render: (h, param) => {
            let data = param.row;
            let operation = [];
            if (this.$hasPermission(this.$route, "edit")) {
              operation.push(
                <a
                  style="color:blue"
                  onClick={this.showAddOrModifyView.bind(this, data)}
                >
                  编缉
                </a>
              );
            }
            return operation;
          },
        },
      ],
      filterObj: {},
      currentRow: [],
      sortObj: {},
    };
  },
  computed: {
    ...mapGetters({
      userInfo: "user",
      getPECommerce: "getPECommerce",
    }),
    ...mapState("channelStore", {
      allChannelList: "allChannelList",
    }),
  },
  methods: {
    ...mapActions("declareEnterpriseStore", {
      list: "listChannelEnterprise",
      addOrModify: "bindConfChannel",
    }),
    fetch() {
      this.loading = true;
      const filterParams = this.getFilterParams();
      const sortObj = this.sortObj;
      let searchCondition = {
        ...sortObj,
        request: JSON.stringify({
          ...filterParams,
          pageInfo: {
            pageIndex: this.pagination.currentPage,
            pageSize: this.pagination.pageSize,
          },
        }),
      };

      this.list(searchCondition)
        .then((res) => {
          this.loading = false;
          this.dataList = res.items || [];
          const pageInfo = res.pageInfo || { totalCount: 0 };
          this.pagination.totalCount = pageInfo.totalCount;
        })
        .catch((error) => {
          this.loading = false;
          this.$message.error("异常");
        });
    },
    showAddOrModifyView(data) {
      if (data != null) {
        this.formData.id = data.id;
        this.formData.channelCode = data.channelCode;
        this.formData.eNid = data.peNid;
        this.formData.payDeclareType =
          data.payDeclareType === "平台侧申报"
            ? "ERP_DECLARE"
            : "MERCHANT_DECLARE";
      } else {
        this.formData = JSON.parse(this.defaultFormData);
      }
      this.showFormDialog = !this.showFormDialog;
    },
    save() {
      this.formData.operator = this.userInfo.nick;
      let param = { request: JSON.stringify(this.formData) };
      this.addOrModify(param)
        .then((res) => {
          if (res.value) {
            this.showFormDialog = !this.showFormDialog;
            this.fetch();
            this.$message.success("保存成功");
          } else {
            this.$message.error("保存失败");
          }
        })
        .catch((error) => {
          this.$message.error("未知异常");
        });
    },
    getFormConfig() {
      const type = this.getFormItemType();
      return [
        {
          data: [
            {
              label: "渠道",
              model: "channelCode",
              type: type.SELECT,
              props: {
                data: this.allChannelList,
              },
            },
            {
              label: "电商平台",
              model: "enterpriseNid",
              type: type.SELECT,
              props: {
                data: this.getPECommerce,
              },
            },
          ],
        },
      ];
    },
  },
};
</script>
